import React from "react";
import LoaderGif from "../../Images/LoaderGif.gif";
// import Logo from "../../images/logo_monotone.png"

const Loader = () => {
  return (
    <div className="absolute inset-0  flex justify-center items-center">
      {/* <div>
                        <img src={Logo} alt="kirtiroadways" width="162" height="59" />
                    </div> */}
      <img src={LoaderGif} alt="Loader" width="500" height="400" />
    </div>
  );
};

export default Loader;
